import { z } from "zod";
/** Одно событие в очереди задачи */
export const TaskEventSchema = z.object({
    index: z.number().int().nonnegative(),
    event: z.string().min(1),
    data: z.unknown(),
});
/** Ответ polling endpoint GET /api/tasks/:taskId */
export const TaskDrainResponseSchema = z.object({
    taskId: z.string().uuid(),
    events: z.array(TaskEventSchema),
    cursor: z.number().int(),
    done: z.boolean(),
});
/** Ответ POST /api/files/upload (новый формат — 202) */
export const UploadStartedResponseSchema = z.object({
    uploadId: z.string().uuid(),
});
//# sourceMappingURL=tasks.js.map